import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AppMaterialModule } from 'app/core/app-material/app-material.module';
import { UserResetPasswordComponent } from 'app/layout/components/user-reset-password/user-reset-password.component';
import { HeaderComponent } from 'app/layout/header/header.component';
import { LayoutComponent } from 'app/layout/layout-component/layout.component';
import { LayoutRoutesModule } from 'app/layout/layout-routes/layout-routes.module';
import { TreeMenuComponent } from 'app/layout/tree-menu/tree-menu.component';
import { ActivitiesModule } from 'app/modules/activity/activities.module';
import { ActivityListService } from 'app/modules/activity/services/activity-list.service';
import { ActivityDocumentUploadService } from 'app/modules/activity/services/activity-document-upload.service';
import { NotesListService } from 'app/modules/activity/services/notes-list.service';
import { PuzzelDownloadService } from 'app/modules/activity/services/puzzel-download.service';
import { DatabaseAuditDialog } from 'app/modules/configuration/database-audit/database-audit-dialog/database-audit-dialog.component';
import { DatabaseAuditListFilterService } from 'app/modules/configuration/database-audit/services/database-audit-list.filter.service';
import { DatabaseAuditListService } from 'app/modules/configuration/database-audit/services/database-audit-list.service';
import { TimeProviderCreateUpdateComponent } from 'app/modules/configuration/time-provider/time-provider-create-update/time-provider-create-update.component';
import { TimeService } from 'app/modules/configuration/time/time.service';
import { UserCreateUpdateComponent } from 'app/modules/configuration/user-list-page/user-create-update/user-create-update.component';
// import { UserResetPasswordComponent } from 'app/modules/configuration/user-list-page/user-reset-password/user-reset-password.component';
import { UserListContainerService } from 'app/modules/configuration/user-list-page/user-list-container/user-list-container.service';
import { CompanyContactFormComponent } from 'app/modules/contacts/company-contact-form/company-contact-form.component';
import { CompanyContactListService } from 'app/modules/contacts/services/company-contact-list.service';
import { UserContactListService } from 'app/modules/contacts/services/user-contact-list.service';
import { BlockUIModule } from 'ng-block-ui';
import { SharedModule } from '../shared/shared.module';
import { AsideContainerComponent } from './components/aside-container/aside-container.component';
import { DefaultAsideComponent } from './components/aside-container/default-aside.component';
import { DashboardCardLinkListComponent } from './components/dashboard/dashboard-card-link-list/dashboard-card-link-list.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { AsideContentDirective } from './directives/aside-content.directive';
import { ProfileService } from './profile/services/profile.service';
import { DivisionThemeService } from './services/division-theme.service';
import { MainMenuService } from './services/main-menu.service';
import { ResponsiveService } from './services/responsive.service';
import { SideMenuComponent } from './side-menu/side-menu.component/side-menu.component';
import { DashboardManagementInformationComponent } from './components/dashboard/dashboard-management-information/dashboard-management-information.component';
import { DashboardService } from './services/dashboard.service';
import { TierOneDashboardComponent } from './components/dashboard/dashboard-management-information/tier-one-dashboard/tier-one-dashboard.component';
import { TierTwoDashboardComponent } from './components/dashboard/dashboard-management-information/tier-two-dashboard/tier-two-dashboard.component';
import { TierThreeDashboardComponent } from './components/dashboard/dashboard-management-information/tier-three-dashboard/tier-three-dashboard.component';
import { SwitchCompanyComponent } from './components/switch-company/switch-company.component';
import { InteractionsCounterComponent } from './components/dashboard/dashboard-management-information/interations-counter/interactions-counter.component';
import { SwitchCompanyLoginComponent } from './components/switch-company-login/switch-company-login.component';
import { CaseClaimListService } from 'app/modules/my-cases/services/case-claim-list.service';
import { TitleService } from './title/title-service.component';
import { TwoFactorComponent } from './components/two-factor/two-factor.component';
import { TwoFactorService } from './components/two-factor/services/two-factor.service';
import { QRCodeComponent } from 'angularx-qrcode';
import { TwoFactorLoginComponent } from 'app/core/security/auth/two-factor-login/two-factor-login.component';
import { HubComponent } from './components/hub/hub.component';
import { CompanyProductListService } from 'app/modules/my-services/services/company-product-list.service';

@NgModule({
  declarations: [
    LayoutComponent,
    HeaderComponent,
    TreeMenuComponent,
    SideMenuComponent,
    DefaultAsideComponent,
    AsideContainerComponent,
    AsideContentDirective,
    UserCreateUpdateComponent,
    UserResetPasswordComponent,
    SwitchCompanyComponent,
    SwitchCompanyLoginComponent,
    TwoFactorLoginComponent,
    TimeProviderCreateUpdateComponent,
    DatabaseAuditDialog,
    WelcomeComponent,
    DashboardComponent,
    HubComponent,
    DashboardCardLinkListComponent,
    DashboardManagementInformationComponent,
    CompanyContactFormComponent,
    TierOneDashboardComponent,
    TierTwoDashboardComponent,
    TierThreeDashboardComponent,
    InteractionsCounterComponent,
    TwoFactorComponent,
  ],
  imports: [
    BrowserModule,
    QRCodeComponent,
    FormsModule,
    ReactiveFormsModule,
    BlockUIModule,
    SharedModule,
    AppMaterialModule,
    ActivitiesModule,
    LayoutRoutesModule // this must be last
  ],
  providers: [
    // ActivitiesModule services hoisted here so they reach the root injector
    // (transitive NgModule providers from 2+ levels deep don't reliably reach root in Angular 21)
    ActivityListService,
    ActivityDocumentUploadService,
    NotesListService,
    PuzzelDownloadService,
    TimeService,
    ResponsiveService,
    MainMenuService,
    ProfileService,
    UserListContainerService,
    AppMaterialModule,
    DatabaseAuditListService,
    DatabaseAuditListFilterService,
    DivisionThemeService,
    CompanyContactListService,
    UserContactListService,
    CompanyProductListService,
    DashboardService,
    CaseClaimListService,
    TitleService,
    TwoFactorService
  ],
  exports: [SwitchCompanyLoginComponent, TwoFactorLoginComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LayoutModule {}
